import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SortConfig } from '../../core/interface/SortConfig';
import { PaginationConfig } from '../../core/interface/PaginationConfig';
import { OfficeLeaseService } from '../../core/services/office-lease.service';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, map, Subject, takeUntil } from 'rxjs';
import { TenantService } from '../../core/services/tenant.service';
import { ContactType, TanantDetail, TenantBuilding, TenantContractReference } from '../../core/models/tenant';

@Component({
  selector: 'app-tenant-business-detail',
  templateUrl: './tenant-business-detail.component.html',
  styleUrl: './tenant-business-detail.component.css'
})
export class TenantBusinessDetailComponent implements OnInit {

  @ViewChild('dropdownMenu', { static: false }) dropdownMenu!: ElementRef;

  itemTenant: TenantBuilding[] = [];
  itemTenantDetail: TanantDetail = {} as TanantDetail
  itemTenantContractType: TenantContractReference[] = [];
  filteredTenant: TenantBuilding[] = []
  isLoading = false;
  error = '';

  // Filters
  searchForm !: FormGroup;
  sortBy = '';
  startDate: string = '';
  endDate: string = '';
  selectedStatus: string = 'All Status';
  sortStatus = 'All';
  searchTerm: string = '';
  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  sortConfig: SortConfig = {
    column: '',
    direction: ''
  };

  paginationConfig: PaginationConfig = {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0
  };

  selectedContractTypeId: any;
  selectedContractType: any = 'All Contract Type';
  filter: string = '';
  ItemContractType: ContactType[] = []
  TenantId: number = 0;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private tenantService: TenantService,
    private renderer: Renderer2
  ) {
    this.setupSearchSubscription();
  }


  private setupSearchSubscription(): void {
    this.searchSubject.pipe(
      takeUntil(this.destroy$),
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(term => {
      // Update URL dan load data hanya jika ada term
      if (term.trim()) {
        this.updateUrlParams();
      }
      this.loadTenantBuilding(term);
    });
  }


  ngOnInit(): void {
    this.TenantId = Number(this.route.snapshot.paramMap.get('id')) || 0
    const startDate = localStorage.getItem('startDate')
    const endDate = localStorage.getItem('endDate')

    this.startDate = startDate ? startDate : '';
    this.endDate = endDate ? endDate : '';

    this.loadTenantBuilding();
    this.loadTenantDetail();
    this.setupFilterSubscription();
    //this.loadTenantContractType();

  }

  private setupFilterSubscription(): void {
    // Subscription untuk filter
    this.route.queryParams
      .pipe(
        takeUntil(this.destroy$),
        map(params => ({
          filter: params['filter'] ? Number(params['filter']) : null,
          search: params['search'] || '',
          page: Number(params['page']) || 1,
          sortColumn: params['sortColumn'] || '',
          sortDirection: params['sortDirection'] || ''
        })),
        distinctUntilChanged((prev, curr) =>
          JSON.stringify(prev) === JSON.stringify(curr)
        )
      )
      .subscribe(params => {
        // Update state dari parameter
        this.searchTerm = params.search;
        this.paginationConfig.currentPage = params.page;
        this.sortConfig.column = params.sortColumn;
        this.sortConfig.direction = params.sortDirection as 'ASC' | 'DESC' | '';

        // Update filter
        const newFilterId = params.filter;
        if (this.selectedContractTypeId !== newFilterId) {
          this.selectedContractTypeId = newFilterId;
          this.updateSelectedMemberTypeName();
        }

        // Hanya load member data
        this.loadTenantBuilding(this.searchTerm);
      });
  }


  private updateSelectedMemberTypeName(): void {
    if (this.selectedContractTypeId !== null && this.ItemContractType.length > 0) {
      const selectedType = this.ItemContractType.find(type => type.area_used === this.selectedContractTypeId);
      if (selectedType) {
        this.selectedContractType = selectedType.contract_ref;
      } else {
        this.selectedContractTypeId = null;
        this.selectedContractType = 'All Contract Type';
      }
    } else {
      this.selectedContractType = 'All Contract Type';
    }
  }

  onContractTypeFilter(contract_ref: any, area_used: any) {
    // console.log('Filtering by:', { contract_ref, area_used });
    this.selectedContractTypeId = contract_ref;
    this.selectedContractType = contract_ref;
    this.updateUrlParams();

    // Hanya load member data saja
    this.loadTenantBuilding(this.searchTerm);

    if (this.dropdownMenu) {
      this.renderer.removeClass(this.dropdownMenu.nativeElement, 'show');
      this.renderer.removeClass(this.dropdownMenu.nativeElement, 'show-custom');
    }
  }

  resetContractTypeFilter() {
    this.selectedContractTypeId = null;
    this.selectedContractType = 'All Contract Type';
    this.updateUrlParams();

    // Hanya load member data saja
    this.loadTenantBuilding(this.searchTerm);

    if (this.dropdownMenu) {
      this.renderer.removeClass(this.dropdownMenu.nativeElement, 'show');
      this.renderer.removeClass(this.dropdownMenu.nativeElement, 'show-custom');
    }
  }

  loadTenantDetail(): void {
    this.isLoading = true;

    this.tenantService.getTenantDetail(
      this.TenantId,
      this.startDate,
      this.endDate,
    ).subscribe({
      next: (response) => {
        this.itemTenantDetail = response.data;
        this.isLoading = false;
        // console.log("Tenant detail loaded successfully:", this.itemTenantDetail);
      },
      error: (error) => {
        console.error('Error loading tenant detail data:', error);
        this.isLoading = false;
        this.itemTenantDetail = {} as TanantDetail;
      }
    });
  }

  get tenantImageUrl(): string {
    return this.itemTenantDetail.logo && this.itemTenantDetail.logo.trim()
      ? this.itemTenantDetail.logo
      : 'assets/images/Empty-State.png';
  }

  loadTenantContractType(): void {
    this.isLoading = true;

    this.tenantService.getTenantContractType(
      this.TenantId,
    ).subscribe({
      next: (response) => {
        this.itemTenantContractType = response.data;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading tenant contract type data:', error);
        this.isLoading = false;
        this.itemTenantContractType = [];
      }
    });
  }


  loadTenantBuilding(searchTerm?: string): void {
    this.isLoading = true;


    this.tenantService.getTenantBuilding(
      this.TenantId,
      this.paginationConfig.currentPage,
      this.paginationConfig.itemsPerPage,
      searchTerm?.trim() || '',
      this.sortConfig.column,
      this.sortConfig.direction.toUpperCase() as 'ASC' | 'DESC',
      this.startDate,
      this.endDate,
      this.selectedContractTypeId
    ).subscribe({
      next: (response) => {
        this.itemTenant = response.data;
        this.paginationConfig.totalItems = response.pagination.total_items;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading tenant data:', error);
        this.isLoading = false;
        this.itemTenant = [];
      }
    });
  }

  get totalPages(): number {
    return Math.ceil(this.paginationConfig.totalItems / this.paginationConfig.itemsPerPage);
  }

  get pageNumbers(): number[] {
    const currentPage = this.paginationConfig.currentPage;
    const totalPages = this.totalPages;

    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }

  onSearch(event: KeyboardEvent): void {
    const target = event.target as HTMLInputElement;
    const term = target.value;

    // Update searchTerm dan trigger pencarian
    this.searchTerm = term;
    this.paginationConfig.currentPage = 1;
    this.searchSubject.next(term);

    // Jika input kosong, langsung clear search dan reset data
    if (!term.trim()) {
      const queryParams: Record<string, string | number | null> = {
        page: 1,
        search: null
      };

      // Jika ada sort config, pertahankan
      if (this.sortConfig.column && this.sortConfig.direction) {
        queryParams['sortColumn'] = this.sortConfig.column;
        queryParams['sortDirection'] = this.sortConfig.direction;
      }

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams,
        replaceUrl: true
      });

      this.loadTenantBuilding('');
    }
  }

  onSort(column: string): void {
    if (this.sortConfig.column === column) {
      this.sortConfig.direction = this.sortConfig.direction === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortConfig.column = column;
      this.sortConfig.direction = 'ASC';
    }

    this.paginationConfig.currentPage = 1; // Reset to first page on sort
    this.updateUrlParams();
    this.loadTenantBuilding(this.searchTerm);
  }

  getSortIcon(column: string): string {
    // Jika bukan kolom yang sedang di-sort, tampilkan icon default
    if (this.sortConfig.column !== column) {
      return 'ri-expand-up-down-line'; // Remix icon untuk unsorted
    }

    // Jika kolom yang sedang di-sort
    if (this.sortConfig.direction === 'ASC') {
      return 'ri-arrow-up-line'; // Remix icon arrow up
    } else if (this.sortConfig.direction === 'DESC') {
      return 'ri-arrow-down-line'; // Remix icon arrow down
    }

    return 'ri-expand-up-down-line'; // Default fallback
  }

  onPageChange(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.paginationConfig.currentPage) {
      return;
    }

    this.paginationConfig.currentPage = page;
    this.updateUrlParams();
    this.loadTenantBuilding(this.searchTerm);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onFirstPage(): void {
    this.onPageChange(1);
  }

  onLastPage(): void {
    this.onPageChange(this.totalPages);
  }

  onPrevPage(): void {
    this.onPageChange(this.paginationConfig.currentPage - 1);
  }

  onNextPage(): void {
    this.onPageChange(this.paginationConfig.currentPage + 1);
  }

  get displayRange(): { start: number; end: number; total: number } {
    const start = (this.paginationConfig.currentPage - 1) * this.paginationConfig.itemsPerPage + 1;
    const end = Math.min(
      start + this.paginationConfig.itemsPerPage - 1,
      this.paginationConfig.totalItems
    );

    return {
      start: this.paginationConfig.totalItems === 0 ? 0 : start,
      end,
      total: this.paginationConfig.totalItems
    };
  }

  private updateUrlParams(): void {
    const queryParams: any = {
      page: this.paginationConfig.currentPage
    };

    // Hanya tambahkan search param jika ada nilai
    if (this.searchTerm?.trim()) {
      queryParams.search = this.searchTerm.trim();
    } else {
      queryParams.search = null; // Hapus search param
    }

    if (this.sortConfig.column && this.sortConfig.direction) {
      queryParams.sortColumn = this.sortConfig.column;
      queryParams.sortDirection = this.sortConfig.direction;
    }

    // Tambahkan parameter memberTypeId jika ada
    if (this.selectedContractTypeId !== null) {
      queryParams.filter = this.selectedContractTypeId;
    } else {
      queryParams.filter = null; // Hapus filter param jika tidak ada
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.paginationConfig.currentPage = 1;
    this.updateUrlParams();
    this.loadTenantBuilding('');
  }
















}
